import { signal } from "@preact/signals-react"

export const marketplacesLBBIsEmpty = signal(false)
export const evolutionDataFilters = signal({})
export const evolutionChartCurrentPeriod = signal("")
export const marketplacesLBBEndDate = signal("")
export const marketplacesLBBReportFormIsOpen = signal(false)
export const marketplacesLBBSubmittedFilters = signal({})

export const resetMarketplacesLostBuyBoxSignal = () => {
    marketplacesLBBIsEmpty.value = false
    evolutionDataFilters.value = {}
    marketplacesLBBReportFormIsOpen.value = false
    marketplacesLBBSubmittedFilters.value = {}
}